import type {
  EditorReactComponent,
  InlineElement,
  EditorElement,
} from '@wix/component-protocol/schema';
import { CompRef } from '@wix/document-services-types';
import { IManifestMiddleware, IManifestStoreEntity } from '../stores';
import {
  VirtualElement,
  VirtualElementAPIType,
} from '../api/providers/VirtualElement';

import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export abstract class AbstractManifestMiddleware
  implements IManifestMiddleware
{
  constructor(protected readonly editorPointerAPI: EditorPointerServiceAPI) {}

  public abstract resolveRootElement(
    node: VirtualElement<VirtualElementAPIType.VirtualManifestAPI>,
    getElementByPointer: (
      pointer: EditorPointer<CompRef>,
    ) => EditorElement | InlineElement | undefined,
  ): EditorReactComponent | null;

  public abstract resolveChildRefElement(
    node: VirtualElement<VirtualElementAPIType.VirtualManifestAPI>,
    getElementByPointer: (
      pointer: EditorPointer<CompRef>,
    ) => EditorElement | InlineElement | undefined,
  ): InlineElement | null;
}
